<template>
  <div class="col-md-4">
    <!-- <div v-html=" HomeUWS.description "></div> -->

    <div class="workshop cardover" >

         <router-link
            :to="{
              name: 'workshop',
              params: { workshopId: HomeUWS.id },
            }"

            >

      <div class="workshop__author-pic">
        <u-live-icon v-if="HomeUWS.category.includes('live')"></u-live-icon>
        <img :src="`https://backend.upskill.com.bd${HomeUWS.image}`" />
      </div>

      <div class="workshop__info">
        <div class="flex spacebetween">
          <p class="workshop__info-date">{{ getTime }}</p>

          <p class="workshop__info-date info-category">
            {{HomeUWS.category}}
          </p>
        </div>
        <h3 class="workshop__info-title">{{ HomeUWS.name }}</h3>

        <!-- <p class="workshop__info-speaker">
          -
        </p> -->
      </div>
      <div class="workshop__action">
        <div class="workshop__action-info" v-if="!hasDiscount">

          <span>{{ HomeUWS.fee !== 0 ? `৳ ${HomeUWS.fee}` : "Free" }}</span>

          <span>{{ getTimeLeft }}</span>
        </div>
        <div class="workshop__action-info" v-else>
          <span
            style="text-decoration: line-through; font-size: 24px; color:#555D50; margin-top: -37px;"
            >{{ HomeUWS.fee >= 0 ? `৳.${HomeUWS.fee}` : "Free" }}</span
          >
          <span style="font-size: 40px; font-weight: 700">{{
            `Tk.${HomeUWS.fee - discountedPrice}`
          }}</span>
          <span>{{ getTimeLeft }}</span>
        </div>
        <div class="workshop__action-register new-col11">
          <router-link
            :to="{
              name: 'workshop',
              params: { workshopId: HomeUWS.id },
            }"
            class="btn btn-success non-cardover"

            >View Workshop</router-link
          >
        </div>
      </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: ["HomeUWS"],
  name: "upcomingworkshop",
  data() {
    return {
      upcomingworkshopdata: [],
      timeleft: "",
      dateNow: "xz",
      hasDiscount: false,
      discountedPrice: 0,
    };
  },
  computed: {
    getTime() {
      // let uptime = moment().format("HomeUWS");
      // this.dateNow = this.HomeUWS.workshop_ts;
      // return moment("this.dateNow", "YYYY-MM-DD hh:mm:ss").format(
      //   "dddd, MMMM Do YYYY, h:mm:ss a"
      // );

      return moment(this.HomeUWS.workshop_ts).format("LT ddd, DD MMMM, YYYY");
    },
    getTimeLeft() {
      // console.log(moment().unix());
      // console.log(moment(this.HomeUWS.workshop_ts).unix() - moment().unix());
      if (moment(this.HomeUWS.workshop_ts).unix() - moment().unix() > 0) {
        return (moment(this.HomeUWS.workshop_ts).fromNow() + " left").replace(
          "in",
          ""
        );
      } else {
        return "registration over";
      }
    },
  },
  methods: {
    getDiscount() {
      this.$upskill
        .discountByWid(this.HomeUWS.id)
        .then((res) => {
          this.discountedPrice = res.data.data.Discount;
          this.hasDiscount = true;
        })
        .catch(() => {
          this.hasDiscount = false;
        });
    },
  },
  created() {
    this.getDiscount();
  },
};
</script>
<style scoped></style>
